class Globals {

  static setXbsEnvironment(environment) {
    this._xbsEnvironment = environment;
  }

  static getXbsEnvironment() {
    return this._xbsEnvironment;
  }

  static setXbsProductUuid(productUuid) {
    this._productUuid = productUuid;
  }

  static getXbsProductUuid() {
    return this._productUuid;
  }
}

module.exports = Globals;